import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['currentvalue', 'list', 'boletotab', 'transfertab', 'spinner', 'filterAll', 'requestTransferButton']
  connect(event) {
    if (!this.hasBoletotabTarget) {
      return
    }
    this.load(event)
  }
  load(event) {
    fetch("/boletos/current_balance.json", {
      headers : {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(response => {
      this.currentvalueTarget.innerHTML = response.balance_formatted
      if (response.balance && response.balance > 0) {
        this.requestTransferButtonTarget.removeAttribute('disabled')
      } else {
        this.requestTransferButtonTarget.setAttribute('disabled', 'disabled')
      }
    })
    this.list(event)
  }
  list(event, filter = null, page = '1') {
    this.boletotabTarget.classList.add('active')
    this.transfertabTarget.classList.remove('active')
    this.listTarget.innerHTML = ''
    this.spinnerTarget.classList.remove('hide')
    fetch("/boleto-dashboard/boletos?"+filter+'&page='+page, {
    })
    .then(response => response.text())
    .then(html => {
      this.listTarget.innerHTML = html
      this.spinnerTarget.classList.add('hide')
    })
    if (event != null) {
      event.preventDefault()
    }
  }
  transfers(event) {
    this.boletotabTarget.classList.remove('active')
    this.transfertabTarget.classList.add('active')
    this.listTarget.innerHTML = ''
    this.spinnerTarget.classList.remove('hide')
    fetch("/boleto-dashboard/transfers", {
    })
    .then(response => response.text())
    .then(html => {
      this.listTarget.innerHTML = html
      this.spinnerTarget.classList.add('hide')
    })
    event.preventDefault()
  }
  filter(event){
    this.list(event, event.currentTarget.value)
  }
  page(event){
    var value = event.currentTarget.value.split("|")
    this.list(event,value[1],value[0])
  }
}
